import { useEffect } from 'react'
import { Controller, useFieldArray, useForm, useFormState } from 'react-hook-form'

import { DEFAULT_VALUES_ADD_RECIPE_SECOND_STEP, OPTIONS_TBLS } from '../../../utils/constants'
import useDirty from '../../../utils/hooks/useDirty'
import { updateRecipe } from '../../../api/admin'

const noop = () => {}
import { EditIcon } from '../../../components/SvgIcon'
import IngredientsItem from '../../../components/IngredientsItem'
import ButtonCustom from '../../../components/ButtonCustom'
import InputSimple from '../../../components/InputSimple'

// save/onSaved/onError/onInvalid let the new admin area show feedback; defaults keep the old page as it was
const IngredientsForm = ({
  required,
  // Whether the recipe stays published; defaults to `required` like before
  toPublish,
  dataRecipe = {},
  idRecipe,
  save = updateRecipe,
  onSaved = noop,
  onError = noop,
  onInvalid = noop,
}) => {
  const { control, handleSubmit, reset } = useForm()
  const { filterDirtyFields } = useDirty()
  const { dirtyFields } = useFormState({ control })
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'ingredients',
  })

  const addNewIngredient = () => {
    append({
      quantity: '',
      measurement: 1,
      name: '',
    })
  }

  const onSubmit = (data) => {
    const newData = filterDirtyFields({ dirtyFields, data })
    return save({ ...newData, id: idRecipe, to_publish: toPublish ?? required })
      .then(() => {
        reset(newData)
        onSaved('Ingredients saved')
      })
      .catch(onError)
  }

  useEffect(() => {
    const filterDataRecipe = filterDirtyFields({
      dirtyFields: DEFAULT_VALUES_ADD_RECIPE_SECOND_STEP,
      data: dataRecipe,
    })

    reset({ ...DEFAULT_VALUES_ADD_RECIPE_SECOND_STEP, ...filterDataRecipe })
  }, [dataRecipe])

  return (
    <form onSubmit={handleSubmit(onSubmit, onInvalid)} className="mb-16">
      <div className="adminUserNameWrap">
        <p className="adminUserTitle">Ingredients</p>
        <button type="submit" className="btnChangeName">
          <EditIcon className="changePencilName" />
        </button>
      </div>
      <div className="innerStepsAdmin">
        <div>
          {fields.map((item, index) => {
            return (
              <IngredientsItem
                key={item.id}
                index={index}
                required={required}
                dirtyFields={dirtyFields}
                control={control}
                dropOptions={OPTIONS_TBLS}
                remove={remove}
              />
            )
          })}
        </div>
        <div className="recipeButtonWrap">
          <ButtonCustom
            type="button"
            onClick={addNewIngredient}
            style="recipeButtonAddIngredient"
            title="+ add another ingredient"
          />
        </div>
      </div>
      <div className="ingredientsCount globalInnerIngredients">
        <div className="ingredientsCount">
          <Controller
            name="amount"
            control={control}
            rules={{
              required,
            }}
            render={({ field, fieldState }) => (
              <InputSimple
                {...field}
                {...fieldState}
                nameInputPlaceholder="ex. 2"
                styleInput="inputRecipeNumber textAlightCenter numberInputCustom"
                className="ingredientsAmount"
              />
            )}
          />

          <div>
            <Controller
              name="measurement"
              control={control}
              rules={{
                required,
              }}
              render={({ field, fieldState }) => (
                <InputSimple
                  {...field}
                  {...fieldState}
                  nameInputPlaceholder="ex. Dozen"
                  styleInput="inputRecipeNumber textAlightCenter numberInputCustom wrapDropDoze"
                  className="ingredientsAmount"
                />
              )}
            />
          </div>
        </div>
      </div>
    </form>
  )
}

export default IngredientsForm
